import { CFormGroup, CInputCheckbox, CLabel } from "@coreui/react";
import { useFormContext } from "react-hook-form";
import { DB_PATHS } from "src/constants";
import { useUpdateDatabase } from "src/hooks";

const DEFAULT_FALSE = ["q1b", "q16"];

const OptionalQuestion = ({ name, children }) => {
  const { isDemo, optionalQuestions } = useFormContext();

  const { setOrUpdateDocument } = useUpdateDatabase();

  const updateSetting = async (shouldShow) => {
    await setOrUpdateDocument(DB_PATHS.project, {
      optionalQuestions: { [name]: shouldShow },
    });
  };

  const shouldShowByDefault = !DEFAULT_FALSE.includes(name);
  const shouldShowQuestion =
    isDemo ||
    (shouldShowByDefault && optionalQuestions?.[name] !== false) ||
    (!shouldShowByDefault && optionalQuestions?.[name] === true);

  return (
    <>
      {isDemo && (
        <CFormGroup
          className="mr-auto mb-2 "
          variant="custom-checkbox"
          style={{ fontSize: "14px" }}
        >
          <CInputCheckbox
            custom
            id={`opinion-questions-${name}`}
            onChange={(e) => {
              const { checked } = e.target;
              updateSetting(checked);
            }}
            checked={optionalQuestions?.[name] ?? true}
          />
          <CLabel
            variant="custom-checkbox"
            htmlFor={`opinion-questions-${name}`}
            className="text-muted"
          >
            Show this question in survey?
          </CLabel>
        </CFormGroup>
      )}
      {shouldShowQuestion && children}
    </>
  );
};

export default OptionalQuestion;
